import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";

export const ButtonPrimaryWrap = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-left: 40px;
    margin-right: 40px;
  }
`;
